import React, { useEffect, useState } from "react";
import Layout from '../form-layout'
import RequiredModal from "../../components/required-modal";
const strugglesOptions = [
  "Sugary Foods e.g. cakes, cookies, donuts etc",
  "Carb rich Foods e.g. bread, pasta, rice etc",
  "Cravings",
  "Boredom Eating",
  "Stress/Emotional Eating",
  "Eating late in the evenings / night time",
  "Snacking all the time",
  "Other struggles - please specify",
];

export default function Step4({ onBack, goToStep, isFirstStep }) {
  const [selectedStruggles, setSelectedStruggles] = useState([]);
  const [otherText, setOtherText] = useState("");
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const savedStruggles = JSON.parse(localStorage.getItem("struggles")) || [];
    const savedOther = localStorage.getItem("otherStruggle") || "";
    setSelectedStruggles(savedStruggles);
    setOtherText(savedOther);
  }, []);

  const handleCheckboxChange = (option) => {
    if (option === "Other struggles - please specify") {
      if (selectedStruggles.some((item) => item.startsWith("Other -"))) {
        setSelectedStruggles(selectedStruggles.filter((item) => !item.startsWith("Other -")));
        setOtherText("");
      } else {
        setSelectedStruggles([...selectedStruggles, `Other - ${otherText}`]);
      }
    } else {
      if (selectedStruggles.includes(option)) {
        setSelectedStruggles(selectedStruggles.filter((item) => item !== option));
      } else {
        setSelectedStruggles([...selectedStruggles, option]);
      }
    }
  };

  const handleOtherChange = (e) => {
    const value = e.target.value;
    setOtherText(value);
    const filtered = selectedStruggles.filter((item) => !item.startsWith("Other"));
    if (value.trim() !== "") {
      setSelectedStruggles([...filtered, `Other - ${value}`]);
    } else {
      setSelectedStruggles(filtered);
    }
  };

  const handleNext = () => {
    const isOtherSelected = selectedStruggles.some((item) => item.startsWith("Other"));
    if (isOtherSelected && otherText.trim() === "") {
      setShowModal(true);
      return;
    }

    localStorage.setItem("struggles", JSON.stringify(selectedStruggles));
    localStorage.setItem("otherStruggle", otherText);

    goToStep("bmi");
  };

  return (
    <Layout goToStep={goToStep} onBack={onBack} isFirstStep={isFirstStep}>
      
      <h2 className="text-sm sm:text-[14px] font-medium text-[#000000] mb-6 pt-3 transition-colors">
       What do you struggle with?
      </h2>

      <div className="space-y-4 mb-6">
        {strugglesOptions.map((option, index) => {
          const isSelected =
            option === "Other struggles - please specify"
              ? selectedStruggles.some((item) => item.startsWith("Other -"))
              : selectedStruggles.includes(option);

          return (
            <div
              key={index}
              className={`flex flex-col p-4 border-2 rounded-xl shadow-sm transition-colors hover:shadow-md`}
            >
              <label className="flex items-center cursor-pointer text-sm sm:text-[14px] font-medium text-[#000000]">
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={() => handleCheckboxChange(option)}
                  className="mr-3 w-5 h-4 accent-sky-400 cursor-pointer"
                />
                {option}
              </label>

              {option === "Other struggles - please specify" && isSelected && (
                <input
                  type="text"
                  value={otherText}
                  onChange={handleOtherChange}
                  placeholder="Type your struggle"
                  className="mt-2 p-2 border-2 border-sky-400 rounded-md w-full  text-sm sm:text-[14px] font-medium text-[#000000] focus:outline-none focus:ring-2 focus:ring-sky-400 transition-colors"
                />
              )}
            </div>
          );
        })}
      </div>

      <div className="flex justify-start">
        <button
          onClick={handleNext}
          className="w-52 bg-[#35C3D9] hover:bg-[#27AAC0] text-white text-sm font-semibold rounded-lg py-3 transition-all duration-300 shadow-md hover:shadow-lg"
        >
          Next →
        </button>
      </div>

      {showModal && (
        <RequiredModal
          message="Please specify your 'Other struggle' before proceeding."
          onClose={() => setShowModal(false)}
        />
      )}
    </Layout>
  );
}
